module.exports = __webpack_public_path__ + "static/media/covidCertificate.11dc94b7.png";